<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-user-plus heroicon heroicon-sm"
  >
    <path
      class="heroicon-user-plus-top heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M2 58v-9c0-.92.78-2.23 1.58-2.66L19 38.04v2.97a7 7 0 0 0 14 0v-2.97l6.21 3.34A11 11 0 0 0 43.41 58H2z"
    ></path>
    <path
      class="heroicon-user-plus-face heroicon-component-fill"
      fill="#FFFFFF"
      d="M31 34.91v6.1a5 5 0 0 1-10 0v-6.1A12 12 0 0 1 14 24V14a12 12 0 1 1 24 0v10a12 12 0 0 1-7 10.91z"
    ></path>
    <circle
      class="heroicon-user-plus-circle heroicon-component-accent heroicon-component-fill"
      cx="48"
      cy="48"
      r="11"
      fill="#7ACFC0"
    ></circle>
    <polygon
      class="heroicon-user-plus-symbol heroicon-component-fill"
      fill="#FFFFFF"
      points="50 46 55 46 55 50 50 50 50 55 46 55 46 50 41 50 41 46 46 46 46 41 50 41"
    ></polygon>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M18.68 35.94l-6.55 3.53A17.96 17.96 0 0 0 26 46c5.58 0 10.57-2.54 13.87-6.53l-6.55-3.53C34.27 35.35 29.89 38 26 38s-8.27-2.65-7.32-2.06z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M38.32 40.9L33 38.05v2.97a7 7 0 0 1-14 0v-2.97l-15.42 8.3A3.57 3.57 0 0 0 2 49v9h5v-4h1v4h33.36a11.99 11.99 0 0 1-3.04-17.1zM52 59.33V60H0V49a5.53 5.53 0 0 1 2.64-4.42l16.05-8.64A14 14 0 0 1 12 24V14a14 14 0 1 1 28 0v10a14 14 0 0 1-6.68 11.94l6.35 3.42A12 12 0 1 1 52 59.32zM31 37.08a13.97 13.97 0 0 1-10 0v3.93a5 5 0 0 0 10 0v-3.93zM14 14v10a12 12 0 0 0 24 0V14a12 12 0 0 0-24 0zm3.05-4.47A10 10 0 0 1 26 4v1a9 9 0 0 0-8.05 4.97l-.9-.44zM48 58a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm2-12h5v4h-5v5h-4v-5h-5v-4h5v-5h4v5zm-1-4h-2v5h-5v2h5v5h2v-5h5v-2h-5v-5z"
    ></path>
  </svg>
</template>
